var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"height-100 text-color-size font-lato"},[_c('span',[_vm._v("対象データが存在しません。再度操作してください。")]),_c('div',[_c('sp-smart-button',{staticClass:"margin-top-5",on:{"click":_vm.homePage}},[_vm._v("ホームページ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }